<template>
  <div id='map' style="height: 250px; width: 100%;"></div>
</template>

<script>
// import gmapsInit from './utils/gmaps';
import gmapsInit from '../../utils/gmaps';

export default {
  name: 'App',
  async mounted() {
    try {
      const google = await gmapsInit();
      const geocoder = new google.maps.Geocoder();
      // const map = new google.maps.Map(this.$el);
      const map = new google.maps.Map(document.getElementById('map'),
        {
          zoom: 13,
        }
      );

      geocoder.geocode({ address: 'Austria' }, (results, status) => {
        if (status !== 'OK' || !results[0]) {
          throw new Error(status);
        }

        map.setCenter(results[0].geometry.location);
        map.fitBounds(results[0].geometry.viewport);
      });
    } catch (error) {
      console.error(error);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/global/MapTest.vue